module.exports = __webpack_public_path__ + "img/home-bar.8c57c164.png";